/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from 'react-helmet-async';
import { _mock } from 'src/_mock';
import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const Departments = () => {
  const _column_data: any = {
    type: {
      'Facility Name': 'text',
      Location: 'text',
      'Department Name': 'text',
      'Cost Center': 'number',
      // 'Parent Department Name': 'singleSelect',
    },
    options: {
      // 'Parent Department Name': _department_name,
    },
    column_questions: {
      // 'Facility Name': 'text',
      // Location: 'text',
      'Department Name': 'What is the department name?',
      'Cost Center': 'What is the department cost center?',
      // 'Parent Department Name': 'If this department has a parent department, it can be listed here.',
    },
  };
  const gridData: any = {
    facilty_list: {
      _dataGrid_0: [...Array(16)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          'Facility Name': _mock.department_module.faculty_name(index),
          Location: _mock.department_module.location(index),
        };
      }),
    },
    departure_list: {
      _dataGrid_0: [...Array(16)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          'Department Name': _mock.department_module.department_name(index),
          'Cost Center': _mock.department_module.cost_center(index),
          // 'Parent Department Name': _mock.parent_department_name(index),
          Facility: _mock.department_module.faculty(index),
        };
      }),
    },
  };
  const TABS = [
    { value: 'facilty_list', label: 'Facilty List', color: 'success' },
    { value: 'departure_list', label: 'Department List', color: 'success' },
  ] as const;

  return (
    <>
      <Helmet>
        <title> Dashboard: Departments</title>
      </Helmet>
      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="Departments"
      />
    </>
  );
};

export default Departments;
